// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ***************************************************************** Policies *******************************************************************
const INDEX_ASSIGNMENT_USER_POLICIES_SUCCESS = 'INDEX_ASSIGNMENT_USER_POLICIES_SUCCESS';
const INDEX_ASSIGNMENT_POSITION_POLICIES_SUCCESS = 'INDEX_ASSIGNMENT_POSITION_POLICIES_SUCCESS';
const STORE_ASSIGNMENT_POLICY_SUCCESS = 'STORE_ASSIGNMENT_POLICY_SUCCESS';

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ***************************************************************** Policies *******************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexUserSuccess(payload) {
  return {
    type: INDEX_ASSIGNMENT_USER_POLICIES_SUCCESS,
    payload: payload,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _indexPositionSuccess(payload) {
  return {
    type: INDEX_ASSIGNMENT_POSITION_POLICIES_SUCCESS,
    payload: payload,
  };
}

/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _storeSuccess(payload) {
  return {
    type: STORE_ASSIGNMENT_POLICY_SUCCESS,
    payload: payload.data,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ***************************************************************** Policies *******************************************************************
/**
 *
 * @param {String} [component]
 * @param {Number} [id]
 * @param {Object} [params]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function index(component = 'user', id, params = {}, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let routes = `positions/${id}/policies`;
    if (component === 'user') {
      routes = `users/${id}/policies`;
    }
    api.get(routes , {params})
      .then((r) => {
        if (component === 'user') {
          dispatch(_indexUserSuccess(r));
        } else {
          dispatch(_indexPositionSuccess(r));
        }
        callback(false, r);
      })
      .catch((e) => {
        callback(e);
      });
  };
}

/**
 *
 * @param {Object} data
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function store(data, callback = () => {
}) {
  return (dispatch, gs, api) => {
    let loader = app.loading(app.translate('routes.home.attendance.policy.Adding New Policy'));

    api.post('/ta/policies/assign', {data})
      .then((r) => {
        dispatch(_storeSuccess(r));
        loader.hide(() => app.message(app.translate('routes.home.attendance.policy.New Policy Added Successfully')));
        callback(r);
      })
      .catch((e) => {
        loader.hide(() => app.error(
          e, 'routes.home.attendance.policy', 'خطا در ارسال اطلاعات',
          app.translate('routes.home.attendance.policy.Adding New Policy Failed'),
        ));
      });
  };
}

/**
 *
 * @return {Function}
 */
export function emptyPolicies() {
  return _indexUserSuccess({data: {policies: []}, meta: {}});
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(state = {
  policies: [],
}, action) {
  let policies;

  switch (action.type) {
    case INDEX_ASSIGNMENT_USER_POLICIES_SUCCESS:
      return Object.assign({}, state, {
        policies: action.payload.data && action.payload.data.user ? action.payload.data.user.policies: [],
      });
    case INDEX_ASSIGNMENT_POSITION_POLICIES_SUCCESS:
      return Object.assign({}, state, {
        policies: action.payload.data? action.payload.data : [],
      });
    case STORE_ASSIGNMENT_POLICY_SUCCESS:
      policies = app._.clone(state.policies);
      policies.push(action.payload);
      return Object.assign({}, state, {
        policies,
      });
    default:
      return state;
  }
}
